<template>
    <div class="birthday-container">
        <div class="container">
            <div class="banner"></div>
            <div class="time">请在生日当月领取{{ birthdayDesc() }}</div>
            <div :class="content.awardList[0].awardStatus === 20 ? 'coupons-gray' : 'coupons'">
                <div class="unit">¥</div>
                <div class="amount">{{ parseInt(content.awardList[0].couponAmount / 100) }}</div>
                <div class="title">息费减免优惠券</div>
                <div class="desc">仅限生日当月领取</div>
                <div class="time">{{ content.awardList[0].effectiveDays }}天 有 效 期</div>

                <div class="coupon-award" v-if="content.awardList[0].awardStatus === 20"></div>
            </div>
            <div class="btn" v-if="getBtnTxt().class" @click="skipOuter()">
                {{ getBtnTxt().desc }}
            </div>
            <div class="btn-bottom-txt" v-if="content.awardList[0].awardStatus === 0">
                升至{{ content.awardList[0].requiredLevel }}可领取
            </div>
            <div class="btn-bottom" v-if="!getBtnTxt().class">
                请耐心等待
            </div>
        </div>
        <Dialog
            :show="showDialog"
            title="前往首页申请借款，成交后即可激活成长权益"
            lefttxt="再看看"
            righttxt="去首页"
            @giveupBtn="giveupBtn"
            @continueBtn="continueBtn"
        />
    </div>
</template>

<script>
import homemixin from '@common/js/mixin';
import Dialog from '../../componets/birthday/homeDialog';
export default {
    name: 'birthday',

    components: {
        Dialog
    },
    mixins: [homemixin],
    data() {
        return {
            showDialog: false,
            btnTxt: '去升级',
            content: {},
            resMsg: '',
            titleBar: {
                fullScreen: 2,
                visible: 1,
                leftView: [
                    {
                        action: 'back',
                        color: '#000000',
                        icon: 'ppdwebui://resource/drawable/nav_back',
                        callback: this.goBacktoHome
                    }
                ],
                titleView: {
                    text: '生日礼券',
                    color: '#000000'
                },
                rightView: []
            }
        };
    },
    created() {
        if (window.PPDWebUI.os.inApp) {
            window.PPDWebUI.CommonService.setNavigation(this.titleBar);
        }
        this.getBirthday();
    },
    methods: {
        goBacktoHome() {
            this.$router.push('/');
        },
        giveupBtn() {
            this.showDialog = false;
        },
        continueBtn() {
            this.showDialog = false;
            this.goHome();
        },
        birthdayDesc() {
            if (this.content.isOldCustomer) {
                return `${this.content.receiveStartTime}至${this.content.receiveEndTime}`;
            } else {
                if (this.content.receiveStartTime) {
                    return `${this.content.receiveStartTime}至${this.content.receiveEndTime}`;
                } else {
                    return '';
                }
            }
        },
        async skipOuter() {
            let couponStatus = this.content.awardList[0].awardStatus;
            if (couponStatus === 0) {
                this.trackerBtn();
                if (this.content.isOldCustomer) {
                    localStorage.setItem('updata', 'true');
                    // this.$router.replace({
                    //     path: '/'
                    // });
                    this.goClose();
                } else {
                    this.showDialog = true;
                }
            } else if (couponStatus === 10) {
                await this.receivebirthdaycoupon();
                this.trackerBtn();
            } else if (couponStatus === 20) {
                this.trackerBtn();
                this.openLink(this.$couponsLink);
            }
        },

        trackerBtn() {
            this.POINT('h5_clk', {
                tgt_event_id: 'h5_ACT_button',
                tgt_name: 'h5_ACT_生日礼券',
                page: 'super-生日礼券',
                param1: `${this.content.level}`,
                param2: `${this.content.awardList[0].awardStatus}`,
                param3: `${this.getBtnTxt().desc}`,
                param4: `${this.content.awardList[0].couponAmount}`,
                param5: `${this.resMsg}`
            });
        },

        async receivebirthdaycoupon() {
            const { Result, ResultMessage } = await this.$http.receivebirthdaycoupon({
                awardKey: this.content.awardList[0].awardKey
            });
            if (Result === 200) {
                this.$toast({
                    message: '领取成功',
                    duration: 2000
                });
                this.getBirthday();
                this.resMsg = '成功';
            } else if (Result === 40708) {
                this.$toast({
                    message: '领取失败，请前往权益首页查看您当前权益。',
                    duration: 2000
                });
                this.resMsg = `失败${ResultMessage}`;
            } else {
                this.resMsg = `失败${ResultMessage}`;
                this.$toast({
                    message: `${ResultMessage}`,
                    duration: 2000
                });
            }
        },
        getBtnTxt() {
            let couponStatus = this.content.awardList[0].awardStatus;
            if (couponStatus === 0) {
                if (this.content.isOldCustomer) {
                    return {
                        desc: '去升级',
                        class: 1
                    };
                } else {
                    return {
                        desc: '去激活',
                        class: 1
                    };
                }
            } else if (couponStatus === 1) {
                return {
                    desc: '请耐心等待',
                    class: 0
                };
            } else if (couponStatus === 10) {
                return {
                    desc: '立即领取',
                    class: 1
                };
            } else if (couponStatus === 20) {
                return {
                    desc: '查看我的优惠券',
                    class: 1
                };
            } else {
                return {
                    desc: '请耐心等待',
                    class: 0
                };
            }
        },
        async getBirthday() {
            const { Result, Content } = await this.$http.getbirthdaycouponpageinfo();
            console.log(Result, Content);
            if (Result === 200) {
                this.content = Content;
                this.POINT('h5_element_imp', {
                    tgt_event_id: 'h5_ACT_imp',
                    tgt_name: 'h5_ACT_生日礼券',
                    page: 'super-生日礼券',
                    param1: `${this.content.level}`,
                    param2: `${this.content.awardList[0].awardStatus}`,
                    param3: `${this.getBtnTxt().desc}`,
                    param4: `${this.content.awardList[0].couponAmount}`
                });
            }
        }
    }
};
</script>

<style lang="less" scoped>
@import '~@common/style/common.less';

.birthday-container {
    height: 100%;
    width: 100%;
    overflow: hidden;
    overflow-y: auto;

    .container {
        width: 100%;

        .banner {
            .backgroundImage(375px, 140px, '~@assets/img/birthday_top_banner.png');
        }

        .time {
            color: #292738;
            .f-12();

            text-align: center;
            margin: auto;
            margin-top: 30px;
            line-height: 18px;
        }

        .coupons {
            width: 303px;
            height: 91px;
            margin: auto;
            margin-top: 20px;
            .backgroundImage(303px, 91px, '~@assets/img/coupon.png');
            position: relative;

            .coupon-award {
                right: 44px;
                top: 10px;
                position: absolute;
                .backgroundImage(71px, 71px, '~@assets/img/coupon_award_icon.png');
            }

            .unit {
                left: 33px;
                top: 30px;
                position: absolute;
                color: #83542a;
                font-size: 14px;
                font-weight: bold;
            }

            .amount {
                left: 44px;
                top: 24px;
                position: absolute;
                color: #83542a;
                .f-42-bold();
                color: rgba(131, 84, 42, 1);
                line-height: 50px;
            }

            .title {
                left: 105px;
                top: 30px;
                right: 92px;
                position: absolute;
                color: #83542a;
                width: 110px;
                .f-15-bold();
            }

            .desc {
                left: 105px;
                top: 53px;
                position: absolute;
                .f-12-bold();
                color: #c0ae93;
            }

            .time {
                right: 21px;
                top: 10px;
                line-height: 15px;
                width: 17px;
                position: absolute;
                .f-12-bold();
                color: #ffffff;
                margin-top: 0px;
            }
        }

        .coupons-gray {
            width: 303px;
            height: 91px;
            margin: auto;
            margin-top: 20px;
            .backgroundImage(303px, 91px, '~@assets/img/coupon_gray.png');
            position: relative;

            .coupon-award {
                right: 44px;
                top: 10px;
                position: absolute;
                .backgroundImage(71px, 71px, '~@assets/img/coupon_award_icon.png');
            }

            .unit {
                left: 33px;
                top: 30px;
                position: absolute;
                color: #787878;
                font-size: 14px;
                font-weight: bold;
            }

            .amount {
                left: 44px;
                top: 24px;
                position: absolute;
                color: #787878;
                .f-42-bold();
                line-height: 50px;
            }

            .title {
                left: 113px;
                top: 30px;
                right: 92px;
                position: absolute;
                color: #787878;
                width: 110px;
                .f-15-bold();
            }

            .desc {
                left: 113px;
                top: 53px;
                position: absolute;
                .f-12-bold();
                color: #787878;
            }

            .time {
                right: 21px;
                top: 10px;
                line-height: 15px;
                width: 17px;
                position: absolute;
                .f-12-bold();
                color: #ffffff;
                margin-top: 0px;
            }
        }

        .btn {
            .backgroundImage(212px, 40px, '~@assets/img/birthday_btn.png');
            margin: auto;
            margin-top: 50px;
            color: #ece0cf;
            .f-16-bold();
            text-align: center;
            line-height: 40px;
        }

        .btn-bottom-txt {
            color: #a4a7b3;
            .f-12-bold();
            margin: auto;
            margin-top: 18px;
            text-align: center;
        }

        .btn-bottom {
            color: #ffffff;
            .f-16-bold();
            text-align: center;
            line-height: 40px;
            margin: auto;
            margin-top: 207px;
            .backgroundImage(212px, 40px, '~@assets/img/birthday_gray_btn.png');
        }
    }
}
</style>
